// import { FormCheckbox } from 'src/components';

import { TableBodyCol, TableBodyRow } from 'src/components';
import { TProductCart } from 'src/store';
import { libFormatPrice } from 'src/toolkit';

import styles from './CartRow.module.scss';


type TProps = TProductCart & {
	// to: string;
	// selectedItems: number[];
	// setSelectedItems: (value: number[]) => void;
};

export function CartRow(props: TProps) {
	const {
		// to,
		// productId,
		name: nameRaw,
		serialNumber,
		price,
		storageName,
		provider,
		brand,
		orderAmount,
		// selectedItems,
		// setSelectedItems,
	} = props;

	const { name: providerName } = provider;
	const { name: brandName } = brand;

	const name = nameRaw ? nameRaw : '—';

	// const nameAttribute = `is_selected_${id}`;
	// const idAttribute = `is-selected-${id}`;

	// const onChange = (value: number) => {
	// 	const isSelected = selectedItems.includes(value);

	// 	if (isSelected) {
	// 		const filteredSelectedItems = selectedItems.filter(item => item !== value);

	// 		setSelectedItems(filteredSelectedItems);
	// 	} else {
	// 		setSelectedItems([...selectedItems, value]);
	// 	}
	// };

	return (
		<TableBodyRow>
			{/* <TableBodyCol className={ styles.idCol }>{ productId }</TableBodyCol> */}

			<TableBodyCol className={ styles.nameCol }>
				{/* <FormCheckbox
					// classNameBox={ styles.checkbox }
					name={ nameAttribute }
					id={ idAttribute }
					// checked={ selectedItems.includes(id) }
					// onChange={ () => onChange(id) }
					// disabled={ isLoading }
				>{ brandName }</FormCheckbox> */}
				{ brandName }
				{/* <Link to={ to }>{ brandName }</Link> */}
			</TableBodyCol>

			<TableBodyCol className={ styles.serialNumberCol }>{ serialNumber }</TableBodyCol>

			<TableBodyCol className={ styles.nameCol }>{ providerName }</TableBodyCol>

			<TableBodyCol className={ styles.descriptionCol }>{ name }</TableBodyCol>

			<TableBodyCol className={ styles.priceCol } right>{ libFormatPrice(price) }</TableBodyCol>

			<TableBodyCol className={ styles.storageNameCol }>{ storageName }</TableBodyCol>

			<TableBodyCol className={ styles.orderAmountCol } right>{ orderAmount }</TableBodyCol>
		</TableBodyRow>
	);
}
